import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllReports, resetAdminReports, resetAdminReportsThunk, fetchEmployeesWithSubmissions } from '../../../store/slices/gameTestingSlice';
import GameTestingReminderNotificationModal from './components/GameTestingReminderNotificationModal';
import TestingReportsList from './components/TestingReportsList';
import './AdminGameTesting.scss';

const AdminGameTesting = () => {
  const dispatch = useDispatch();
  const { isAdmin } = useSelector(state => state.auth);
  
  useEffect(() => {
    // Reset admin reports when component mounts
    dispatch(resetAdminReports());
    dispatch(resetAdminReportsThunk());
    
    // Fetch initial reports and employee data
    dispatch(fetchAllReports({ 
      itemsPerPage: 10,
      lastVisible: null,
      filters: {}
    }));
    
    // Fetch employees with submissions for the reminder modal
    dispatch(fetchEmployeesWithSubmissions());
    
    // Cleanup when component unmounts
    return () => {
      dispatch(resetAdminReports());
      dispatch(resetAdminReportsThunk());
    };
  }, [dispatch]);
  
  return (
    <div className="admin-game-testing-container">
      <section className="page-heading">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="mb-0">Game/App Testing Dashboard</h3>
          <GameTestingReminderNotificationModal />
        </div>
      </section>
      
      <div className="admin-game-testing-content">
        <TestingReportsList />
      </div>
    </div>
  );
};

export default AdminGameTesting; 